const getDrivesList = state => state?.driveData?.drivesList
const getDriveDetail = state => state?.driveData?.drivesDetail
const getDriveDateCalender =  state => state?.driveData?.driveDateCalender
const selector = {
    getDrivesList,
    getDriveDetail,
    getDriveDateCalender
}

export default selector
